import Phase2Workspace from "./Phase2Workspace.jsx";
import { Phase2Records, Phase2Insights, phase2SearchText } from "./Phase2Records.jsx";
import OnDemandPDFExport from "./exports/OnDemandPDFExport.jsx";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useReactToPrint } from "react-to-print";
import { serverHost } from "../../../../http_common.js";
import { purchaseSummary, purchaseDate, purchaseAmount } from "./exports/OrdersPDFExport.jsx";
import { matchesPurchaseFilters } from "./filters/FilterOders.jsx";
import PreviewRecieves from "./previews/PreviewRecieves.jsx";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./recieves.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Action from "../../../../store/redux/client_reducer.js";
import { useSnackbar } from "notistack";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
import IsLoading from "../../../../IsLoading.jsx";
import FilterRecieves from "./filters/FilterRecieves.jsx";
import ExportExcelJSButton from "./exports/RecivesExcelExport.jsx";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI
import ShortTextIcon from "@mui/icons-material/ShortText";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AddIcon from "@mui/icons-material/Add";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";

import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// image imports
import InsertRecieve from "./create/InsertRecieves.jsx";


export default function Recives({ breadcrumbs, data, setIsMobileNavOpen }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("grid");
  const [accordion, setAccordion] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [displayedComponent, setDisplayedComponent] = useState("main-display");

  const [recievesData, setRawRecords] = useState([]);
  const [filters, setFilters] = useState({ rules: [], sort: "newest", from: "", to: "" });
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [noteText, setNoteText] = useState("");
  const listPrintRef = useRef(null);
  const printList = useReactToPrint({ contentRef: listPrintRef, documentTitle: "Purchase Receive Records" });
  const writePending = useRef(false);
  const requestSerial = useRef(0);
  const activeClient = useRef(data?.clientId);
  activeClient.current = data?.clientId;

  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);
  const currentTab = useSelector((state) => state.clientFunction?.dashboard?.currentTab);
  const [quickSearch,setQuickSearch] = useState('');
  const normalizedQuery=quickSearch.trim().toLocaleLowerCase();
  const searchIndex=useMemo(()=>new Map(recievesData.map(record=>[record,phase2SearchText(record,'receive')])),[recievesData]);
  const summaryIndex=useMemo(()=>new Map(recievesData.map(record=>[record,purchaseSummary(record,'receive')])),[recievesData]);
  const filteredData = useMemo(() => {
    const records = recievesData.filter((record) => {
      const summary = summaryIndex.get(record);
      if (currentTab === "completed" && ["COMPLETE", "COMPLETED", "RECEIVED"].includes(summary.status.toUpperCase())) return false;
      return matchesPurchaseFilters(summary, filters);
    });
    return records.filter(record=>!normalizedQuery || searchIndex.get(record)?.includes(normalizedQuery)).sort((left, right) => {
      const a = summaryIndex.get(left), b = summaryIndex.get(right);
      if (filters.sort === "amount-high") return Number(b.amount || 0) - Number(a.amount || 0);
      if (filters.sort === "amount-low") return Number(a.amount || 0) - Number(b.amount || 0);
      const compare = (new Date(b.date || 0).getTime() || 0) - (new Date(a.date || 0).getTime() || 0);
      return filters.sort === "oldest" ? -compare : compare;
    });
  }, [summaryIndex, filters, currentTab, normalizedQuery, searchIndex]);
  useEffect(()=>{setCurrentPage(1);},[quickSearch]);
  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentRows = filteredData.slice(start, end);
  useEffect(() => { setCurrentPage((page) => Math.min(page, totalPages)); }, [totalPages]);
  useEffect(() => { setCurrentPage(1); setAccordion(null); }, [filters, currentTab]);
  useEffect(() => { setAccordion(null); }, [currentPage, rowsPerPage]);

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////

  const apiFetchRecieves = useCallback(async (signal) => {
    if (!data?.clientId || activeClient.current !== data.clientId) return;
    const request = ++requestSerial.current;
    const current = () => request === requestSerial.current && activeClient.current === data.clientId && !signal?.aborted;
    setLoading(true);
    try {
      const response = await axios.get(`${serverHost}/purchases/client/${encodeURIComponent(data.clientId)}/get_receives`, { signal });
      if (response.data.status !== 201) throw new Error(response.data.message || "Unable to load purchases.");
      if (current()) setRawRecords(Array.isArray(response.data.recievesData) ? response.data.recievesData : []);
    } catch (error) {
      if (current()) { setRawRecords([]); enqueueSnackbar(error.response?.data?.message || error.message || "Unable to load purchases.", { variant: "error" }); }
    } finally { if (current()) setLoading(false); }
  }, [data?.clientId, enqueueSnackbar]);

  const openPreview = (record) => { setSelectedRecord(record); setModalInfo("previewAlpha"); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setModalInfo(""); };
  const savedRecord = (record) => { if (record?.clientId && record.clientId !== activeClient.current) return; closeModal(); setDisplayedComponent("main-display"); setSelectedRecord(record); setCurrentPage(1); apiFetchRecieves(); };
  const editNotes = (record) => { setSelectedRecord(record); setNoteText(record.inspection?.notes || record.reasonSummary || ""); setModalInfo("edit-notes"); setModalOpen(true); };
  const saveNotes = async () => {
    if (!selectedRecord || writePending.current) return;
    writePending.current = true; setLoading(true);
    try {
      const response = await axios.post(`${serverHost}/client/${encodeURIComponent(data.clientId)}/purchases/insert_recieve`, {
        action: "UPDATE_NOTES", receiveId: selectedRecord.receiveId, inventoryId: selectedRecord.inventoryId,
        expectedRevision: selectedRecord.revision || 0, notes: noteText,
      });
      if (response.data.status !== 200) throw new Error(response.data.message);
      if (activeClient.current !== data.clientId) return;
      enqueueSnackbar(response.data.message, { variant: "success" }); savedRecord(response.data.info);
    } catch (error) { if (activeClient.current === data.clientId) enqueueSnackbar(error.response?.data?.message || error.message, { variant: "error" }); }
    finally { writePending.current = false; if (activeClient.current === data.clientId) setLoading(false); }
  };

  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////
  function handleCurrentTAB(item) {
    dispatch(DispatchCurrentTAB(item));
  }
  const DispatchCurrentTAB = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispatchCurrentTAB({ item }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };
  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  function switchActiveTab() { return <ToDo />; }

  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF recieves PAGE
  // //////////////////////////////////////////////////////////////////////////

  function ToDo() {
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <TableView currentRows={currentRows} />;
      }
    }
    function TableView({currentRows}){ return <Phase2Records rows={currentRows} kind="receive" view="table" onPreview={openPreview} onEdit={editNotes} />; }


    function CardView({currentRows}){ return <Phase2Records rows={currentRows} kind="receive" view="grid" onPreview={openPreview} onEdit={editNotes} />; }

    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {filteredData.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        filteredData.length,
                      )} of ${filteredData.length} entries`}
                </span>
              </span>
              <div className="recieves_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="recieves-page-limit">
                  <button
                    className="recieves-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="recieves-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="recieves-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="recieves-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="recieves_row" id="printable">{!currentRows.length && <p>No saved purchase records match this view.</p>}
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="recieves_pagination fx-ac space2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages).map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`recieves_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  disabled={currentPage >= totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const applyPeriod = (period) => {
    const today = new Date(), first = new Date(today);
    let last = today;
    if (period === "week") first.setDate(today.getDate() - (today.getDay() + 6) % 7);
    if (period === "month") first.setDate(1);
    if (period === "year") first.setMonth(0, 1);
    if (period === "last-month") { first.setMonth(today.getMonth() - 1, 1); last = new Date(today.getFullYear(), today.getMonth(), 0); }
    const localDay = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    setFilters((current) => ({ ...current, from: localDay(first), to: localDay(last) }));
    handleCurrentTAB("recieves");
  };

  function handleModalFunction(toggleModal, displayModal) {
    if (toggleModal && displayModal === "previewAlpha" && !selectedRecord) { enqueueSnackbar("Select a purchase record before opening its preview.", { variant: "info" }); return; }
    setModalInfo(displayModal);
    setModalOpen(toggleModal);
  }
  function loopingModalInfo() {
    switch (modalInfo) {
      case "filters": return <FilterRecieves filters={filters} onApply={setFilters} onClose={closeModal} currentRows={filteredData} />;
      case "previewAlpha": return <PreviewRecieves receiveItem={selectedRecord} onClose={closeModal}  />;
      case "create": return <InsertRecieve onCreated={savedRecord} onClose={closeModal} onCancel={closeModal} />;
      case "edit-notes": return <div id="createCont" className="fx-cl space2"><h3>Edit Notes</h3><p>Stock quantities and values remain linked to the posted record.</p><textarea className="input-field" value={noteText} onChange={(event) => setNoteText(event.target.value)} /><div className="fx-ac space1"><button className="submitOrdersBtn" disabled={loading} onClick={saveNotes}>Save Notes</button><button className="controlButtons" onClick={closeModal}>Close</button></div></div>;
      default: return null;
    }
  }
  function MobileUi({ setIsMobileNavOpen }) {
    const [showCard, setShowCard] = useState("");
    const cardRef = useRef(null);

    // Close when clicking outside
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (cardRef.current && !cardRef.current.contains(e.target)) {
          setShowCard("");
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
    return (
      <div
        id="mobileRWDInvDisp"
        className="salesMobileUi computerRWDhide fx-cl space3"
      >
        <div className="fx-ac fx-jb space2">
          <button onClick={() => setIsMobileNavOpen(true)}>
            <ShortTextIcon style={{ color: "#818181", fontSize: "3.8rem" }} />
          </button>
          <div className="fx-cl">
            <span className="fs3 fw500">Transactions</span>
            {/* <span className="fs1 fw200">Lorem ipsum dolor sit amet cons</span> */}
          </div>
          <div className="fx-ac fx-jc spacem" style={{ color: "#818181" }}>
            <figure>
              <PrintOutlinedIcon style={{ fontSize: "3.8rem" }} onClick={printList} />
            </figure>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                onClick={() => setShowCard("exports")}
              >
                <ScreenShareOutlinedIcon style={{ fontSize: "3.8rem" }} />
              </button>

              {showCard === "exports" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <div className="fx-ac spacem"><OnDemandPDFExport currentRows={filteredData} kind="receive" label="Export PDF" /></div>
                  <ExportExcelJSButton currentRows={filteredData} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="fx-cl spacem">
          <div className="fx-ac fx-jb space3">
            <span className="lightGrayMbl fx-jc fs1">
              {filteredData.length === 0
                ? "0 to 0 of 0 entries"
                : `${start + 1} - ${Math.min(
                    end,
                    filteredData.length,
                  )} of ${filteredData.length} `}
            </span>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                style={{ color: "#3a84f8" }}
                onClick={() => setShowCard("transactions")}
              >
                All transactions
              </button>

              {showCard === "transactions" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("today"); setShowCard(""); }}>Today</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("week"); setShowCard(""); }}>This Week</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("month"); setShowCard(""); }}>This Month</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("last-month"); setShowCard(""); }}>Last Month</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("year"); setShowCard(""); }}>This year</button>
                </div>
              )}
            </div>
          </div>
          <div className="mobileUiItemsCont fx-cl space1">
            {currentRows?.map((item) => (
              <div
                className="mobileUiItemCard fx-cl"
                key={item?._id || purchaseSummary(item, "receive").id}
              >
                <div className="topContents fx-ac space2">
                  <figure className="mblImgCard">
                    <InsertDriveFileIcon style={{ fontSize: "3.7rem" }} />
                  </figure>

                  <div className="fx-cl spacem" style={{ flexGrow: "1" }}>
                    <span className="fw500">
                      Items: {item?.items?.length || 0}
                    </span>

                    <span className="fs1 lightGrayMbl">
                      {item?.supplier?.name || "Not recorded"}
                    </span>

                    <div className="fx-jb fx-ac">
                      <span className="fw500 fs4">
                        {purchaseAmount(purchaseSummary(item, "receive").amount, purchaseSummary(item, "receive").currency)}
                      </span>

                      <span className="fs1v lightGrayMbl">
                        {purchaseSummary(item, "receive").status}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="bottomConts fx-ac space3 fx-jb">
                  <div className="fx-cl spacem">
                    <span className="fs1 lightGrayMbl">Id: {purchaseSummary(item, "receive").id}</span>
                    <span className="fs3 fw500">{purchaseDate(purchaseSummary(item, "receive").date)}</span>
                  </div>

                  <div className="fx spacem">
                    <button
                      onClick={(e) => {
                        openPreview(item);
                      }}
                    >
                      View Receive
                    </button>
                    <button
                      className="fx-ac fx-jc"
                      aria-label="Preview Receive"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPreview(item);
                      }}
                    >
                      <ReceiptLongIcon fontSize="large" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="fx-jc">
            <div className="sales_pagination fx-ac space2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Previous
              </button>
              <div className="fx-ac">
                {getPagination(currentPage, totalPages).map((page, i) =>
                  page === "..." ? (
                    <span key={i} className="dots">
                      …
                    </span>
                  ) : (
                    <button
                      key={i}
                      className={`sales_jumpto ${
                        currentPage === page ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  ),
                )}
              </div>

              <button
                disabled={currentPage >= totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // One presentation owner: the legacy toolbar, mobile duplicate, list and pagination
  // are intentionally not mounted. Business handlers above are preserved unchanged.
  function MainUi() {
    return <Phase2Workspace
      kind="receive" title="Purchase receives" description="Review incoming items, accepted units and inspection notes." section="purchases"
      records={filteredData} query={quickSearch} onQueryChange={setQuickSearch}
      filters={filters} onFiltersChange={setFilters}
      currentTab={currentTab} tabs={[{value:'recieves',label:'All receives'},{value:'completed',label:'Pending'}]} onTabChange={handleCurrentTAB}
      view={changeview === 'grid' ? 'grid' : 'table'} onViewChange={setChangeView}
      currentPage={currentPage} onPageChange={setCurrentPage}
      pageSize={rowsPerPage} onPageSizeChange={setRowsPerPage}
      onPreview={openPreview} onEdit={editNotes}
      createLabel="Receive items" onCreate={() => handleModalFunction(true, 'create')}
      onRefresh={() => apiFetchRecieves()}
      onPrint={printList} printRef={listPrintRef}
      renderExcel={rows => <ExportExcelJSButton currentRows={rows} />}
      loading={loading} error={undefined}
      mobileNav={setIsMobileNavOpen}
    />;
  }

  function controlDisplay() {
    switch (displayedComponent) {
      case "main-display":
        return MainUi();
      case "item-previewed":
        return <PreviewRecieves receiveItem={selectedRecord} onClose={() => setDisplayedComponent("main-display")} />;
      default:
        return MainUi();
    }
  }
  useEffect(() => {
    const controller = new AbortController();
    setRawRecords([]); setSelectedRecord(null); closeModal(); setDisplayedComponent("main-display"); setCurrentPage(1); setFilters({ rules: [], sort: "newest", from: "", to: "" });
    apiFetchRecieves(controller.signal);
    return () => { controller.abort(); requestSerial.current++; };
  }, [apiFetchRecieves]);
  return (
    <div className="recievesCompContainer p2-root" style={{ paddingTop: "clamp(1.5rem, 2vw, 2.3rem)" }}>
      {modalOpen && (
        <div
          className="client_modal_overlay fx-jc fx-ac"
          onClick={() => handleModalFunction(false, "")} // click outside → close
        >
          <div
            className="client_modal"
            onClick={(e) => e.stopPropagation()} // click inside → stay open
          >
            {loopingModalInfo()}
          </div>
        </div>
      )}
      {controlDisplay()}
    </div>
  );
}
